import type { Book, Currency } from "../../entities/ledger/types";
import { apiRequest } from "../../shared/api/client";

const encode = encodeURIComponent;

export function listBooks(includeArchived = true): Promise<{ books: Book[] }> {
  return apiRequest(`/v1/books?includeArchived=${includeArchived}`);
}

export function createBook(input: { name: string; baseCurrency: Currency; reportingCurrency?: Currency }): Promise<{ book: Book }> {
  return apiRequest("/v1/books", { method: "POST", body: input });
}

// Presentation only: the base currency and every posting stay as they are.
export function updateBook(bookID: string, patch: { name?: string; reportingCurrency?: string }): Promise<{ book: Book }> {
  return apiRequest(`/v1/books/${encode(bookID)}`, { method: "PATCH", body: patch });
}

export function archiveBook(bookID: string): Promise<{ book: Book }> {
  return apiRequest(`/v1/books/${encode(bookID)}/archive`, { method: "POST", body: {} });
}

export function restoreBook(bookID: string): Promise<{ book: Book }> {
  return apiRequest(`/v1/books/${encode(bookID)}/restore`, { method: "POST", body: {} });
}
